import { supabase } from './api'

export const revalidate = 0

export async function getAllData() {
	const { data, error } = await supabase.from('studentpersonalquestion').select()

	if (error) {
		throw new Error('Failed to fetch data')
	}

	return data
}

export async function getDataWithType(type) {
	const { data, error } = await supabase.from('studentpersonalquestion').select().eq('type', type)

	if (error) {
		throw new Error('Failed to fetch data')
	}

	return data
}

export async function getIdData(id) {
	const { data, error } = await supabase.from('studentpersonalquestion').select().eq('id', id)
	if (error) {
		throw new Error('Failed to fetch data')
	}

	return data
}

export async function getStudentIdData(id) {
	const { data, error } = await supabase.from('studentpersonalquestion').select().eq('studentId', id)
	if (error) {
		throw new Error('Failed to fetch data')
	}

	return data
}

export async function addData(adata) {
	const { data, error } = await supabase.from('studentpersonalquestion').insert(adata).select()
	console.log('adata', adata, data, error)
	if (error) {
		throw new Error('Failed to fetch data')
	}

	return data
}

export async function updateData(udata) {
	const { data, error } = await supabase.from('studentpersonalquestion').update(udata).eq('id', udata.id).select()
	console.log('udata', udata, data, error)
	if (error) {
		throw new Error('Failed to fetch data')
	}

	return data
}

export async function deleteIdData(id) {
	const { data, error } = await supabase.from('studentpersonalquestion').delete().eq('id', id)
	if (error) {
		throw new Error('Failed to fetch data')
	}

	return data
}
